@if (loadingWrapper.data$|async; as materialList) {
  <table class="table whitetable business-order-view-table business-order-create"
    >
    <thead>
      <tr>
        <th colspan="4">Auf BA gebuchtes Material</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Fertigungsschritt</strong></td>
        <td><strong>Artikel</strong></td>
        <td><strong title="Mindesthaltbarkeit">Min. Halt.</strong></td>
        <td><strong>Menge</strong></td>
        <td><strong>Spezifikation</strong></td>
      </tr>
      @if (materialList.length === 0) {
        <tr>
          <td colspan="5">Es ist noch kein Material auf diesen BA gebucht</td>
        </tr>
      }
      @for (material of materialList; track material) {
        <tr>
          <td><strong>{{material.bo_step_nr}}</strong>&nbsp;{{material.bo_step_name}}</td>
          <td><strong>{{material.variation_id}}</strong>&nbsp;{{material.article_name}}</td>
          <td>
            {{material.date_expiration|date:'dd.MM.yyyy'}}
          </td>
          <td>
            <a uiSref="a.material.inventory.update" [uiParams]="{variation: material.id}">
              <strong>{{material.amount|money}}</strong>&nbsp;{{ material.charge ? '(' + material.charge + ')' : '' }}
            </a>
          </td>
          <td>
            @for (fieldValue of material.article_fields; track fieldValue) {
              {{fieldValue.name}}: <strong>{{formatValue(fieldValue)}}</strong><br />
            }
            @for (fieldValue of material.variation_fields; track fieldValue) {
              {{fieldValue.name}}: <strong>{{formatValue(fieldValue)}}</strong><br />
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error
  #loadingOrError
  [loadingWrapper]="loadingWrapper"
  [errorMessage]="'Konnte auf BA gebuchtes Material nicht laden'">
</loading-or-error>
